var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlaytn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38975 18.0132L14.4694 2.0126C15.6516 1.91607 18.7252 2.33117 21.5623 4.76384C18.262 8.06532 11.4055 14.9724 8.38975 18.0132Z",
    fill: "url(#paint0_linear_1004_118)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2848 4.03983L2.02059 13.3072C1.89996 15.0448 2.25219 19.1137 4.62615 21.4885C6.07369 17.4919 9.66841 8.19082 11.2848 4.03983Z",
    fill: "url(#paint1_linear_1004_118)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7071 23.1537C15.4537 28.3086 8.82401 25.3016 6.29082 23.1537L13.9628 15.5516C15.6998 17.2892 19.6805 21.2423 21.7071 23.1537Z",
    fill: "url(#paint2_linear_1004_118)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1546 21.5609C25.3018 19.0268 28.3079 12.3949 23.1546 6.13946C21.2439 8.16669 17.2921 12.1487 15.5551 13.8864L23.1546 21.5609Z",
    fill: "url(#paint3_linear_1004_118)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1004_118",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38975 18.0132L14.4694 2.0126C15.6516 1.91607 18.7252 2.33117 21.5623 4.76384C18.262 8.06532 11.4055 14.9724 8.38975 18.0132Z",
    fill: "url(#paint4_linear_1004_118)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2848 4.03983L2.02059 13.3072C1.89996 15.0448 2.25219 19.1137 4.62615 21.4885C6.07369 17.4919 9.66841 8.19082 11.2848 4.03983Z",
    fill: "url(#paint5_linear_1004_118)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7071 23.1537C15.4537 28.3086 8.82401 25.3016 6.29082 23.1537L13.9628 15.5516C15.6998 17.2892 19.6805 21.2423 21.7071 23.1537Z",
    fill: "url(#paint6_linear_1004_118)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1546 21.5609C25.3018 19.0268 28.3079 12.3949 23.1546 6.13946C21.2439 8.16669 17.2921 12.1487 15.5551 13.8864L23.1546 21.5609Z",
    fill: "url(#paint7_linear_1004_118)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1004_118)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1004_118)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.92916,
    ry: 5.9291,
    transform: "matrix(-0.697187 0.716889 -0.716657 -0.697426 19.7004 21.6141)",
    fill: "url(#paint8_linear_1004_118)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1004_118",
    x: 12.2215,
    y: 14.1332,
    width: 14.9578,
    height: 14.9618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.775385,
    result: "effect1_foregroundBlur_1004_118"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1004_118",
    x1: 21.56,
    y1: 4.4,
    x2: 9.9821,
    y2: 22.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FE3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6022F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1004_118",
    x1: 21.56,
    y1: 4.4,
    x2: 9.9821,
    y2: 22.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FE3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6022F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1004_118",
    x1: 21.56,
    y1: 4.4,
    x2: 9.9821,
    y2: 22.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FE3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6022F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1004_118",
    x1: 21.56,
    y1: 4.4,
    x2: 9.9821,
    y2: 22.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FE3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6022F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1004_118",
    x1: 21.56,
    y1: 4.4,
    x2: 9.9821,
    y2: 22.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FE3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6022F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1004_118",
    x1: 21.56,
    y1: 4.4,
    x2: 9.9821,
    y2: 22.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FE3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6022F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1004_118",
    x1: 21.56,
    y1: 4.4,
    x2: 9.9821,
    y2: 22.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FE3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6022F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1004_118",
    x1: 21.56,
    y1: 4.4,
    x2: 9.9821,
    y2: 22.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FE3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6022F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1004_118",
    x1: 6.49248e-8,
    y1: 4.85108,
    x2: 10.1514,
    y2: 6.73765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4016A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4016A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlaytn);
export default __webpack_public_path__ + "static/media/klaytn.8ecded74d3b2c5d519c1ee5cc206cb8b.svg";
export { ForwardRef as ReactComponent };